import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { CallToActionTileModel } from '@/types/B2BcontentServerContract';
import BaseLayout2575and7525 from '@/shared/content/blocks/call-to-action-layouts/shared/BaseLayout2575and7525.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CallToAction2575Layout',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as { content: CallToActionTileModel }



const textTileContentBlock = computed(() => {
    return props.content.tiles[1].model;
});

const mediaTileContentBlock = computed(() => {
    return props.content.tiles[0].model;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BaseLayout2575and7525, {
      "background-color": __props.content.backgroundColor,
      "text-color": __props.content.textColor,
      "alternative-link-style": __props.content.alternativeLinkStyle,
      "link-at-bottom-of-image": __props.content.positionLinkAtBottomOfImage,
      "flip-image-and-text": __props.content.flipImageAndText,
      "text-tile-content-block": _unref(textTileContentBlock),
      "media-tile-content-block": _unref(mediaTileContentBlock)
    }, null, 8, ["background-color", "text-color", "alternative-link-style", "link-at-bottom-of-image", "flip-image-and-text", "text-tile-content-block", "media-tile-content-block"])
  ]))
}
}

})